var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { calculate } from "./formula";
export var clr = "<clr>";
export var clrEnd = "<clrEnd>";
export var PLAYER_KEYS_TO_REPLACE = [
    "Ranger",
    "Player",
    "FromPlanet",
    "FromStar",
    "ToPlanet",
    "ToStar",
    "Money",
    "Date",
    "Day",
    "CurDate",
]; // TODO: Maybe move from here
/**
 * Replaces:
 *    <>        -> value of parameter with index = diamongIndex (if provided)
 *   {1+2}      -> parse formula, using random
 *   <Ranger>   -> player.Ranger and others
 *   [p22]      -> Value of parameter
 *   [d1]       -> Param 1 text with current value
 *   [d1:440 + 4]   -> Param 1 text with value = 444 (see tests for supported cases)
 *
 * All replaced values have <clr>...<clrEnd> around them
 *
 *
 * TODO: Use scanning method, go char by char.
 * Do not use .replace due to side-effect of special chars
 *
 *
 */
export function substitute(str, player, paramValues, paramShowInfos, random, diamondIndex) {
    var e_1, _a, e_2, _b;
    if (diamondIndex !== undefined) {
        str = str.replace(/<>/g, "[p" + (diamondIndex + 1) + "]");
    }
    var searchPosition = 0;
    while (true) {
        var dIndex = str.indexOf("[d", searchPosition);
        if (dIndex === -1) {
            break;
        }
        var paramIndexStr = "";
        var scanIndex = dIndex + 2;
        while (true) {
            var currentChar = str[scanIndex];
            if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(currentChar) === -1) {
                break;
            }
            scanIndex++;
        }
        paramIndexStr = str.substring(dIndex + 2, scanIndex);
        if (paramIndexStr === "") {
            console.warn("No param index found in '" + str + "' at " + dIndex);
            searchPosition = scanIndex;
            continue;
        }
        var paramIndex = parseInt(paramIndexStr) - 1;
        var paramValue = paramValues[paramIndex];
        if (paramValue === undefined) {
            scanIndex++;
            str = str.slice(0, dIndex) + clr + "UNKNOWN_PARAM" + clrEnd + str.slice(scanIndex);
            continue;
        }
        if (str[scanIndex] === "]") {
            // Just keep param value as is
            scanIndex++;
        }
        else if (str[scanIndex] === ":") {
            // Replace param value with formula
            scanIndex++;
            var formulaStartIndex = scanIndex;
            var formulaEndIndex = formulaStartIndex;
            while (str[scanIndex] === " ") {
                scanIndex++;
            }
            // And here goes the formula parsing
            // TODO: Use parse() method without throwing errors
            // So, parse() should read the expression and return the index where it ends
            // Now we just using naive implementation and counting square brackets
            var squareBracketsCount = 0;
            while (true) {
                if (str[scanIndex] === "[") {
                    squareBracketsCount++;
                }
                else if (str[scanIndex] === "]") {
                    if (squareBracketsCount === 0) {
                        formulaEndIndex = scanIndex;
                        scanIndex++;
                        break;
                    }
                    else {
                        squareBracketsCount--;
                    }
                }
                scanIndex++;
                if (scanIndex > str.length) {
                    console.warn("No closing bracket found in '" + str + "' at " + formulaStartIndex);
                    break;
                }
            }
            var formulaWithMaybeCurlyBrackets = str.substring(formulaStartIndex, formulaEndIndex);
            var formula = formulaWithMaybeCurlyBrackets;
            var insideCurlyBracketsMatch = formulaWithMaybeCurlyBrackets.match(/\s*\{(.*)\}\s*/);
            if (insideCurlyBracketsMatch) {
                formula = insideCurlyBracketsMatch[1];
            }
            paramValue = calculate(formula, paramValues, random);
        }
        else {
            console.warn("Unknown symbol in '" + str + "' at " + scanIndex);
            break;
        }
        try {
            // TODO: This is very similar to getParamsState function, maybe better to refactor
            for (var _c = (e_1 = void 0, __values(paramShowInfos[paramIndex].showingInfo)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var range = _d.value;
                if (paramValue >= range.from && paramValue <= range.to) {
                    var paramString = substitute(range.str, player, paramValues, paramShowInfos, random, diamondIndex);
                    str = str.slice(0, dIndex) + clr + paramString + clrEnd + str.slice(scanIndex);
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        searchPosition = scanIndex;
    }
    while (true) {
        var m = str.match(/{[^}]*}/);
        if (!m) {
            break;
        }
        var formulaWithBrackets = m[0];
        var result = calculate(formulaWithBrackets.slice(1, formulaWithBrackets.length - 1), paramValues, random);
        str = str.replace(formulaWithBrackets, "" + clr + result + clrEnd);
    }
    try {
        for (var PLAYER_KEYS_TO_REPLACE_1 = __values(PLAYER_KEYS_TO_REPLACE), PLAYER_KEYS_TO_REPLACE_1_1 = PLAYER_KEYS_TO_REPLACE_1.next(); !PLAYER_KEYS_TO_REPLACE_1_1.done; PLAYER_KEYS_TO_REPLACE_1_1 = PLAYER_KEYS_TO_REPLACE_1.next()) {
            var k = PLAYER_KEYS_TO_REPLACE_1_1.value;
            str = str.split("<" + k + ">").join("" + clr + player[k] + clrEnd);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (PLAYER_KEYS_TO_REPLACE_1_1 && !PLAYER_KEYS_TO_REPLACE_1_1.done && (_b = PLAYER_KEYS_TO_REPLACE_1.return)) _b.call(PLAYER_KEYS_TO_REPLACE_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    for (var ii = 0; ii < paramValues.length; ii++) {
        while (str.indexOf("[p" + (ii + 1) + "]") > -1) {
            str = str.replace("[p" + (ii + 1) + "]", "" + clr + paramValues[ii] + clrEnd);
        }
    }
    return str;
}
//# sourceMappingURL=data:application/json;base64,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